import { Button, Card, Space } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import UpdateSubscriptionType from "./UpdateSubscriptionType";
import { EditOutlined } from "@ant-design/icons";

function SubscriptionTypesTable() {
  const columns = [
    {
      title: "Name",
      dataIndex: "subscription_name",
    },
    {
      title: "Price",
      dataIndex: "price",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => editRecord(record)}>
                <EditOutlined />
              </Button>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/subscription-type?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
  }, [responseData]);

  const handleEditSubscription = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };
  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  return (
    <Card title="Subscription Types">
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        clientSideRender={true}
      />
      {visibleEdit && (
        <UpdateSubscriptionType
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditSubscription}
        />
      )}
    </Card>
  );
}

export default SubscriptionTypesTable;
